<top-bar-tabs></top-bar-tabs>
@if (hasLoaded) {
  <div>
    <mat-sidenav-container>
      <mat-sidenav
        #missingSidenav
        mode="side"
        position="end"
        [fixedInViewport]="true"
        [fixedTopGap]="62"
        class="missing-data-container">
        <div>
          <span class="side-nav-exit">
            <button mat-icon-button color="warn" (click)="missingDataNav.close()">
              <mat-icon>clear</mat-icon>
            </button>
          </span>
          <span class="side-nav-title">
            <mat-icon>assignment</mat-icon>
            Missing Data
          </span>
          @for (section of requirementsData; track section) {
            <div>
              <ul>
                <li class="missing-data-header">
                  @if (!section.value.anchor) {
                    <span>{{ section.type }}</span>
                  }
                  @if (section.value.anchor) {
                    <span
                      (click)="scrollToSection(section.value.anchor)"
                      class="linked">
                      {{ section.type }}
                    </span>
                  }
                  <ul>
                    @for (data of section.value.requirements; track data) {
                      <li
                        class="missing-data-list">
                        @if (data.field) {
                          <span>
                            Fill in <b>{{ data.field }}</b
                            >@if (data.subsection) {
                            <span>
                              in the {{ data.subsection }} Section</span
                              >
                              }.
                            </span>
                          }
                          @if (data.custommessage) {
                            <b> {{ data.custommessage }}. </b>
                          }
                        </li>
                      }
                    </ul>
                  </li>
                </ul>
              </div>
            }
          </div>
        </mat-sidenav>
        <mat-sidenav-content>
          <div class="row" id="deal_profile">
            <div class="col-md-12">
              <div class="container-background">
                <div class="row gutters centered">
                  <mat-card appearance="outlined" class="col-12">
                    <mat-card-content>
                      <div class="row align-top">
                        <div class="col-md-2">
                          <div class="row">
                            <div class="col-md-12 profile-photo">
                              @if (
                                !isEditMode ||
                                !this.permissions.projectPhotoPermissions?._edit
                                ) {
                                <img
                            [src]="
                              projectProfile.image?.length
                                ? projectProfile.image
                                : 'assets/img/property_placeholder.png'
                            "
                            [alt]="
                              'Property Image' +
                              (projectProfile.image?.length
                                ? ''
                                : ' Placeholder')
                            " />
                              }
                              @if (
                                isEditMode &&
                                this.permissions.projectPhotoPermissions?._edit
                                ) {
                                <uploader
                                  [uploading]="photoUploadState.uploading"
                                  [success]="photoUploadState.success"
                                  [errorMessage]="photoUploadState.errorMessage"
                                  [previewImage]="true"
                                (upload)="uploadPhoto($event)"></uploader>
                              }
                            </div>
                            <div
                              class="col-md-12"
                          [ngClass]="
                            isEditMode && checkFormError() ? 'disabled' : ''
                          ">
                              <!--                      this.permissions.projectPhotoPermissions._edit ||-->
                              @if (
                                this.permissions.projectDetailPermissions._edit ||
                                this.permissions.projectDriveFolderPermissions
                                ._edit ||
                                hasICPermissions
                                ) {
                                <button
                                  mat-raised-button
                                  (click)="changeEditMode()"
                                  [disabled]="isEditMode && checkFormError()"
                                  class="deal-save-button"
                            [ngClass]="
                              isEditMode && checkFormError() ? 'disabled' : ''
                            ">
                                  @if (!isEditMode) {
                                    <span>Edit Profile</span>
                                  }
                                  @if (isEditMode) {
                                    <span>Save Changes</span>
                                  }
                                </button>
                              }
                            </div>
                            <!--            <br>-->
                            <!--            <input type="file"-->
                            <!--                   *ngIf="this.permissions.projectPhotoPermissions._edit && isEditMode"-->
                            <!--                   (change)="uploadImage($event)"-->
                            <!--                    accept="image/*">-->
                          </div>
                        <!-- </mat-card-content> -->
                      <!-- </mat-card> -->
                    </div>
                    <div class="col-md-8">
                      @if (!isEditMode) {
                        <div class="deal-profile">
                          <div class="top-profile-section">
                            <h2 class="deal-name">{{ projectProfile.name }}</h2>
                            <h4 class="deal-type">
                              {{ project.projectType.name }}
                            </h4>
                            @if (project.projectDetail.fully_disposed) {
                              <h4
                                class="fully-disposed"
                                >
                                Fully Disposed
                              </h4>
                            }
                            @if (projectProfile.entity) {
                              <div>
                                Operating Entity:
                                <span class="profile-label">{{
                                  projectProfile.entity
                                }}</span>
                              </div>
                            }
                            @for (sponsor of sponsors; track sponsor) {
                              @if (sponsor.value.length > 0) {
                                <div>
                                  {{ sponsor.key }}:
                                  @for (val of sponsor.value; track val; let last = $last) {
                                    <span class="profile-label">
                                      <a href="{{ dataFormat.formatLink(val)}}" target="_blank">
                                        {{val.nickname}}@if (!last) {
                                        <span>,</span>
                                      }</a>
                                      &nbsp;@if (val.originatorRelationship!==null) {
                                      <small>(<a href="{{dataFormat.formatLink(val.originatorRelationship.person)}}" target="_blank">{{val.originatorRelationship.person.name}}</a>)</small>
                                    }
                                  </span>
                                }
                              </div>
                            }
                          }
                          @if (project.developer.length > 0) {
                            <div>
                              Developer:
                              <span class="profile-label"
                                ><a
                                href="{{
                                  dataFormat.formatLink(
                                    project.developer[0].organization
                                  )
                                }}" target="_blank"
                                >{{ project.developer[0].organization.name }}</a
                                ></span
                                >&nbsp;@if (project.developer[0].organization.sponsor !== null && project.developer[0].organization.sponsor.originatorRelationship!==null) {
                                <small>(<a href="{{dataFormat.formatLink(project.developer[0].organization.sponsor.originatorRelationship.person)}}" target="_blank">{{ project.developer[0].organization.sponsor.originatorRelationship.person.name}}</a>)</small>
                              }
                            </div>
                          }
                          @if (middleTierEntities.length > 0) {
                            <div>
                              Middle-Tier Entities:
                              @for (entity of middleTierEntities; track entity) {
                                <span
                                  class="mid-tier-label"
                                  >{{ entity.ownedEntityOwner.name }},</span
                                  >
                                }
                              </div>
                            }
                            @if (projectProfile.ein) {
                              <div>
                                EIN:
                                <span class="profile-label">{{
                                  projectProfile.ein
                                }}</span>
                              </div>
                            }
                            @if (projectProfile.ic_code) {
                              <div>
                                IC Code:
                                <span class="profile-label">{{
                                  projectProfile.ic_code
                                }}</span>
                              </div>
                            }
                            @if (project.projectDetail.risk_rating) {
                              <div>
                                Risk Rating:
                                <span class="profile-label">{{
                                  project.projectDetail.risk_rating
                                }}</span>
                              </div>
                            }
                            <div>
                              Repeat Deal: <span class="profile-label">{{project.is_repeat ? "Yes" : "No"}}</span>
                            </div>
                          </div>
                          @if (address) {
                            <div class="bottom-profile-section">
                              <div class="flex">
                                <mat-icon class="mat-icon-style">place</mat-icon>
                                {{ addressOneLine }}
                              </div>
                              @if (address.latitude && address.longitude) {
                                <div
                                  class="flex">
                                  <mat-icon class="mat-icon-style">explore</mat-icon>
                                  {{ address.latitude }}, {{ address.longitude }}
                                </div>
                              }
                            </div>
                          }
                          @if (projectProfile.path) {
                            <div
                              class="bottom-profile-section flex">
                              <mat-icon class="mat-icon-style">folder</mat-icon>
                              {{ projectProfile.path }}
                              <mat-icon
                                class="mat-icon-copy"
                                #tooltip="matTooltip"
                                [matTooltipPosition]="position.value!"
                                matTooltip="Copy the Deal Folder Path"
                                (click)="copyToClipboard()">
                                content_copy
                              </mat-icon>
                            </div>
                          }
                          @if (project.is_synced_link === true) {
                            <div
                              class="bottom-profile-section flex"
                              >
                              <mat-icon class="mat-icon-style"
                                >contact_mail</mat-icon
                                ><a (click)="goToLink(creaLinkPath + project.id)"
                                >CREALink</a
                                >
                              </div>
                            }
                            @if (project.sharepoint_folder) {
                              <div class="flex">
                                <img
                                  src="assets/img/Microsoft-SharePoint-Logo.png"
                                  class="sharepoint-image" /><a
                            (click)="
                              goToLink(
                                sharepointLink + project.sharepoint_folder
                              )
                            "
                                  >SharePoint</a
                                  >
                              </div>
                            }
                            @if (project.teams_url) {
                              <div class="flex">
                                <img
                                  src="assets/img/teams-logo.png"
                                  class="teams-image" /><a
                                  (click)="goToLink(project.teams_url)"
                                  >Teams</a
                                  >
                              </div>
                            }
                          </div>
                        }
                        @if (isEditMode) {
                          <div class="deal-profile">
                            <form [formGroup]="profileForm">
                              @if (
                                (permissions.projectDetailPermissions._edit &&
                                closingStatus !== 'Closed') ||
                                (closingStatus === 'Closed' &&
                                hasDealNamePermissions)
                                ) {
                                <div
                                  class="row align-top gutters"
                                  >
                                  <div class="col-md-12">
                                    <mat-form-field>
                                      <mat-label>Name</mat-label>
                                      <input
                                        matInput
                                        type="text"
                                        name="name"
                                        formControlName="name"
                                        (keyup)="updateDetails = true" />
                                    </mat-form-field>
                                  </div>
                                </div>
                              }
                              @if (
                                profileForm.get('name').hasError('required')
                                ) {
                                <div
                                  class="row align-top gutters"
                                  >
                                  <div class="col-md-12">
                                    <small class="error-text"
                                      >Deal Name is required</small
                                      >
                                    </div>
                                  </div>
                                }
                                @if (permissions.projectDetailPermissions._edit) {
                                  <div
                                    class="row align-top gutters"
                                    >
                                    <div class="col-md-12">
                                      <mat-form-field>
                                        <mat-label>Operating Entity</mat-label>
                                        <input
                                          matInput
                                          type="entity"
                                          name="entity"
                                          formControlName="entity"
                                          (keyup)="updateDetails = true" />
                                      </mat-form-field>
                                    </div>
                                  </div>
                                }
                                @if (
                                  profileForm.get('entity').hasError('required')
                                  ) {
                                  <div
                                    class="row align-top gutters"
                                    >
                                    <div class="col-md-12">
                                      <small class="error-text"
                                        >Operating Entity is required</small
                                        >
                                      </div>
                                    </div>
                                  }
                                  @if (
                                    permissions.projectDetailPermissions._edit &&
                                    !profileForm.get('entity').hasError('required') &&
                                    (project.ownedEntity != null ||
                                    projectProfile.entityid)
                                    ) {
                                    <div
                                      class="row align-top gutters"
                                      >
                                      <div class="col-md-12">
                                        <mat-form-field>
                                          <mat-label>Middle-Tier Entity</mat-label>
                                          <input
                                            matInput
                                            type="mid_tier"
                                            name="mid_tier"
                                            formControlName="mid_tier" />
                                        </mat-form-field>
                                        @if (
                                          profileForm.get('mid_tier').value !== null &&
                                          profileForm.get('mid_tier').value.length > 0
                                          ) {
                                          <button
                                            mat-mini-fab
                                            matTooltip="Save middle-tier entity"
                                            class="add-midtier-btn"
                                            (click)="addMidTierTag()">
                                            <mat-icon>save</mat-icon>
                                          </button>
                                        }
                                      </div>
                                    </div>
                                  }
                                  @if (permissions.projectDetailPermissions._edit) {
                                    <div
                                      class="row align-top gutters"
                                      >
                                      <div class="col-md-12">
                                        @for (entity of middleTierEntities; track entity) {
                                          <mat-chip-row
                                            (removed)="removeMidTierTag(entity)">
                                            {{ entity.ownedEntityOwner.name }}
                                            <button matChipRemove>
                                              <mat-icon>cancel</mat-icon>
                                            </button>
                                          </mat-chip-row>
                                        }
                                      </div>
                                    </div>
                                  }
                                  @if (permissions.projectDetailPermissions._edit) {
                                    <div
                                      class="row align-top gutters"
                                      >
                                      <div class="col-md-12">
                                        <mat-form-field>
                                          <mat-label>EIN</mat-label>
                                          <input
                                            matInput
                                            type="ein"
                                            name="ein"
                                            formControlName="ein"
                                            (keyup)="updateDetails = true"
                                            [max]="10" />
                                        </mat-form-field>
                                      </div>
                                    </div>
                                  }
                                  @if (
                                    profileForm.get('ein').hasError('maxlength')
                                    ) {
                                    <div
                                      class="row align-top gutters"
                                      >
                                      <div class="col-md-12">
                                        <small class="error-text"
                                          >EIN must be 10 characters or less</small
                                          >
                                        </div>
                                      </div>
                                    }
                                    @if (hasICPermissions) {
                                      <div
                                        class="row align-top gutters"
                                        >
                                        <div class="col-md-12">
                                          <mat-form-field>
                                            <mat-label>IC Code</mat-label>
                                            <input
                                              matInput
                                              type="ic_code"
                                              name="ic_code"
                                              formControlName="ic_code"
                                              (keyup)="updateDetails = true"
                                              [max]="8" />
                                          </mat-form-field>
                                        </div>
                                      </div>
                                    }
                                    @if (
                                      profileForm.get('ic_code').hasError('maxlength')
                                      ) {
                                      <div
                                        class="row align-top gutters"
                                        >
                                        <div class="col-md-12">
                                          <small class="error-text"
                                            >IC Code must be 8 characters or less</small
                                            >
                                          </div>
                                        </div>
                                      }
                                      @if (
                                        permissions.projectDriveFolderPermissions._edit
                                        ) {
                                        <div
                                          class="row align-top gutters"
                                          >
                                          <div class="col-md-12">
                                            <mat-form-field>
                                              <mat-label>Y Drive Directory</mat-label>
                                              <input
                                                matInput
                                                type="path"
                                                name="path"
                                                formControlName="path"
                                                (keyup)="updateDetails = true" />
                                            </mat-form-field>
                                          </div>
                                        </div>
                                      }
                                    </form>
                                  </div>
                                }
                              </div>
                              <div class="col-md-2">
                                <!--                      <div class="row" *ngIf="permissions.projectPermissions._delete">-->
                                <!--                        <div class="col-12">-->
                                <!--                          <button-->
                                <!--                            mat-raised-button-->
                                <!--                            class="delete-deal-button"-->
                                <!--                            color="warn"-->
                                <!--                            (click)="deleteDealConfirmation()"-->
                                <!--                          >-->
                                <!--                            DELETE DEAL-->
                              <!--                          </button>-->
                            <!--                        </div>-->
                          <!--                      </div>-->
                          <div class="row">
                            <div class="col-12">
                              <jump-to-section [sections]="this.sectionSelect">
                              </jump-to-section>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-12">
                              <button
                                mat-raised-button
                                (click)="toggleAll(true)"
                                class="expand-button">
                                Expand All
                              </button>
                              <button mat-raised-button (click)="toggleAll(false)">
                                Collapse All
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-card-content>
                  </mat-card>
                  <mat-accordion multi>
                    @for (section of sectionSelect; track section) {
                      <div
                        class="row align-top centered gutters">
                        <ng-container
                    [ngTemplateOutlet]="
                      !!section.subSections ? componentsLoop : componentsSwitch
                    "
                          [ngTemplateOutletContext]="{ section: section }">
                        </ng-container>
                      </div>
                    }
                  </mat-accordion>
                  <ng-template #componentsLoop let-section="section">
                    @for (subSection of section.subSections; track subSection) {
                      <ng-container
                        [ngTemplateOutlet]="componentsSwitch"
                        [ngTemplateOutletContext]="{ section: subSection }">
                      </ng-container>
                    }
                  </ng-template>
                  <ng-template #componentsSwitch let-section="section">
                    @if (section.class) {
                      <mat-expansion-panel
                        id="{{ idForSection(section) }}"
                        class="{{ section.class }}"
                        [(expanded)]="section.expanded">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{ section.name }}
                            @if (section.name === 'Pricing') {
                              <a
                                href="https://app.powerbi.com/groups/me/apps/ef49264e-6a0c-422c-903a-35546a1ffcf8/reports/fe883309-510d-4ceb-9229-badb040fa186/"
                                class="open-report mat-elevation-z2"
                                matTooltip="Open Pricing Tracker"
                                (click)="clickExternalLink($event)"
                                target="_blank"
                                ><mat-icon [inline]="true">launch</mat-icon></a
                                >
                              }
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          @if (section.name === 'Statuses') {
                            <deal-status-and-pipeline-dates
                              [statuses]="statuses"
                              [dates]="pipelineProjects"
                              [permissions]="permissions"
                              [sequences]="sequences"
                              [projectID]="project.id"
                              [projectName]="project.name"
                              [projectCredits]="projectCredits"
                              [developer]="project.developer"
                              [deadSequence]="deadSequence"
                              [deadStatus]="deadStatus"
                              [pipelineProjects]="pipelineProjects"
                              [hasRequirements]="hasRequirements"
                              [forecastApprovalID]="forecastApprovalDateTypeID"
                              [forecastDates]="projectMilestoneDates"
                              [subsequences]="subsequences"
                              [(projectSubstatusDates)]="project.projectSubstatusDates"
                              [(projectSubstatuses)]="project.projectSubstatuses"
                              (requirementsChange)="handleMissingRequirements($event)"
                              (applicationsChange)="changeApplications($event)">
                            </deal-status-and-pipeline-dates>
                          }
                          @if (section.name === 'Address') {
                            <deal-addresses
                              [address]="address"
                              [entityID]="project.properties[0].entity.id"
                            (addressChange)="passAddress($event)"></deal-addresses>
                          }
                          @if (section.name === 'Deal Dates') {
                            <deal-dates
                              [dates]="project.projectDates"
                              [effective]="project.projectDetail.effective_closing_date"
                              [loi]="project.projectDetail.loi_expiration_date"
                              [projID]="project.id"
                              [projDetailID]="project.projectDetail.id"
                              [statuses]="project.projectStatuses"
                              [permissions]="permissions"
                              [actualDateClass]="actualDateClass"
                              [targetDateClass]="targetDateClass"
                              [projectDetail]="project.projectDetail"
                              [dateTypes]="dateTypes">
                            </deal-dates>
                          }
                          @if (section.name === 'Deal Information') {
                            <deal-information
                              [attributeTypes]="attributeTypes"
                              [project]="project"
                              [permissions]="permissions"
                            [ltmodels]="project.ltmodels"></deal-information>
                          }
                          @if (section.name === 'Tax Credits') {
                            <deal-tax-credits
                              [projectCreditStatuses]="projectCreditStatuses"
                              [taxCreditTypes]="taxCreditTypes"
                              [taxCreditDesignations]="taxCreditDesignations"
                              [projectCredits]="project.projectCredits"
                            [projectid]="project.id"></deal-tax-credits>
                          }
                          @if (section.name === 'Participants') {
                            <deal-participants
                              [participants$]="participants$"
                              [developer]="project.developer"
                              [roles]="roles"
                              [projectid]="project.id"
                    (participantsChange)="
                      passParticipants($event)
                    "></deal-participants>
                          }
                          @if (section.name === 'Credit Outlets') {
                            <deal-credit-outlets
                              [project]="project"
                              [sequences]="syndicationsStatuses"
                              [fundProjectStates]="fundProjectStates"
                    [projectCredits]="
                      project.projectCredits
                    "></deal-credit-outlets>
                          }
                          @if (section.name === 'Pricing') {
                            <deal-pricing
                              [dates]="project.projectDates"
                              [projectid]="project.id"
                              [permissions]="permissions"
                              [placementExpDateID]="placementGuidanceExpDateID"
                              [placementIssuedDateID]="placementGuidanceIssuedDateID"
                              [responseToDevID]="responseToDevNeededID"
                              [actualDateClassID]="actualDateClass.id"
                              [pricingDetails]="pricingDetails"
                              [participants$]="participants$"
                              [roles]="roles"
                              (participantsChange)="passParticipants($event)">
                            </deal-pricing>
                          }
                          @if (section.name === 'Loans') {
                            <deal-loans
                              [loansFromModels]="project.ltmodels"
                              [loansFromProject]="project.financingTerms"
                    [closingNotes]="
                      project.projectDetail.closing_feasibility_notes
                    "
                              [rateLock]="project.projectDetail.rate_locked_flag"
                              [permissions]="permissions"
                              [projectID]="project.id"
                              [projectDetailsID]="project.projectDetail.id"
                              [loanTypes]="loanTypes"
                              [financingTermType]="loanFinancingTermType">
                            </deal-loans>
                          }
                          @if (section.name === 'LT Model Exports') {
                            <deal-lt-model-exports
                            [ltmodels]="project.ltmodels"></deal-lt-model-exports>
                          }
                          @if (section.name === 'Notes') {
                            <deal-notes
                              [acquisitions]="project.notes"
                              [syndications]="project.projectDetail.syndications_notes"
                              [permissions]="permissions"
                              [projectID]="project.id"
                            [projectDetailID]="project.projectDetail.id"></deal-notes>
                          }
                          @if (section.name === 'ESG & Supportive Services') {
                            <deal-esg-supportive-services
                              [project]="project"
                              [permissions]="permissions"
                    [setAsideTypes]="
                      setAsideTypes
                    "></deal-esg-supportive-services>
                          }
                          @if (section.name === 'Tax Credit Applications') {
                            <deal-tax-credit-applications
                              [applications]="applications"
                              [permissions]="permissions"
                              [projectID]="project.id"
                    (projectStatusChange)="
                      updateProjectStatusFromApp($event)
                    "></deal-tax-credit-applications>
                          }
                          @if (section.name === 'Dispositions') {
                            <deal-dispositions-section
                              [dispositions]="project.dispositions"
                    [projectDetails]="
                      project.projectDetail
                    "></deal-dispositions-section>
                          }
                          @if (section.name === 'Construction') {
                            <deal-construction
                              [construction]="project.creawebConstructionField"
                              [permissions]="permissions"
                            [projectid]="project.id"></deal-construction>
                          }
                          @if (section.name === 'Asset Management') {
                            <deal-asset-management
                              [assetManagement]="project.creawebAssetManagementField"
                              [permissions]="permissions"
                            [projectid]="project.id"></deal-asset-management>
                          }
                        </mat-expansion-panel>
                      }
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </mat-sidenav-content>
        </mat-sidenav-container>
      </div>
    }
